module.exports = __webpack_public_path__ + "img/favicon-lnf.ae8123dc.png";